import {NavLink as Link} from 'react-router-dom';
import React from 'react';
import update from 'immutability-helper';
import DatePicker, {registerLocale} from 'react-datepicker';
import dpLocale from 'date-fns/locale/nb';
import MakeModelVariantField from '../misc/MakeModelVariantField.js';
import warrantyPeriodModel from '../../../../model/warrantyPeriod';

import './WarrantyPeriod.scss';

import 'react-datepicker/dist/react-datepicker.css';
registerLocale('nb', dpLocale);

class WarrantyPeriodTester extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      search: false,
      searching: false,
      error: false,
      errorText: false,
      warrantyObjects: null,
      make: null,
      model: null,
      regDate: null,
      modelYear: null,
      electric: false,
      van: false,
      mgImport: false,
      usedImport: false
    };
    this.defaultState = this.state;

    this.handleFieldChange = this.handleFieldChange.bind(this);
    this.handleMakeModelVariantChange = this.handleMakeModelVariantChange.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.resetSearch = this.resetSearch.bind(this);

    document.title = 'Admin - Garantitester';
  }

  handleFieldChange(e) {
    const newData = {};
    const state = this.state;

    if (e.target.type === 'checkbox') {
      e.target.value = e.target.checked;
    }

    newData[e.target.name] = {
      $set: e.target.value
    };

    const props = update(state, newData);

    this.setState(props);
  }

  handleMakeModelVariantChange(selections) {
    const state = this.state;
    const change = {};

    change['make'] = {
      $set: selections.make
    };
    change['model'] = {
      $set: selections.model
    };

    const props = update(state, change);

    this.setState(props);
  }

  handleDateChange(inputName, date) {
    const event = {
      target: {
        name: inputName,
        value: date
      }
    };

    this.handleFieldChange(event);
  }

  resetSearch() {
    this.setState(this.defaultState);
  }

  handleSearch() {
    this.setState({
      warrantyObjects: null,
      search: false,
      searching: true,
      error: false,
      errorText: null
    });

    // Verify inputs
    if (!this.state.regDate || !this.state.make || !this.state.model) {
      this.setState({
        error: true,
        errorText: 'Feil: Registreringsdato og/eller merke/modell mangler.',
        searching: false,
        search: false
      });
      return false;
    }
    const makeName = this.state.make.title.toLowerCase();

    // Build params
    const contentfulParams = {
      'content_type': 'warrantyPeriod',
      'sys.archivedAt[exists]': false,
      'fields.make.sys.contentType.sys.id': 'bilmerker',
      'fields.make.sys.id': this.state.make.id,
      'fields.electric': (this.state.electric === 'true' || this.state.electric === true)
    };

    if (makeName === 'mitsubishi') {
      contentfulParams['fields.model.sys.contentType.sys.id'] = 'model';
      contentfulParams['fields.model.sys.id'] = this.state.model.id;
      if (this.state.mgImport === 'true' || this.state.mgImport === true) {
        contentfulParams['fields.mgImport'] = true;
      }
      if (this.state.usedImport === 'true' || this.state.usedImport === true) {
        contentfulParams['fields.usedImport'] = true;
      }
    }

    // console.log('params', contentfulParams);
    warrantyPeriodModel.getByParams(contentfulParams, 2).then((warrantyPeriods) => {
      if (warrantyPeriods) {
        const warrantyObjects = warrantyPeriods.map((wp) => {
          if (makeName === 'mitsubishi') {
            // Need to parse json-objects and match against regyear and modelyear. MMC ONLY
            const jsonReg = wp.jsonReg;
            const jsonBattery = wp.jsonBattery;
            const modelYear = this.state.modelYear;
            const regYear = this.state.regDate.getFullYear();
            if (jsonReg) {
              // Find standard warranties for car based on year registered
              const activeRegWarranty = jsonReg.find((period) => {
                return parseInt(period.year, 10) === parseInt(regYear, 10);
              });
              if (activeRegWarranty) {
                wp.standardWarrantyText = activeRegWarranty.standard;
                wp.rustWarrantyText = activeRegWarranty.rust;
                wp.paintWarrantyText = null;
              }
            }
            if (jsonBattery) {
              // Find battery/ev-component warranty based on model year
              const activeBatteryWarranty = jsonBattery.find((period) => {
                return parseInt(period.year, 10) === parseInt(modelYear, 10);
              });
              if (activeBatteryWarranty) {
                wp.batteryWarrantyText = activeBatteryWarranty.battery;
              }
            }
          }

          return wp;
        });

        this.setState({
          search: true,
          searching: false,
          error: false,
          errorText: null,
          warrantyObjects: warrantyObjects
        });
      } else {
        this.setState({
          search: true,
          searching: false,
          error: true,
          errorText: 'Fant ingen garantidata for denne sammensetningen.',
          warrantyObjects: null
        });
      }
    });
  }

  render() {
    let mmvCls = 'success';
    if (!this.state.make || !this.state.model) {
      mmvCls = 'warning';
    }

    const makeName = (this.state.make ? this.state.make.title.toLowerCase() : null);
    const warrantyObjects = this.state.warrantyObjects;

    return (
      <section className="mf-model mf-padding-top-20">
        <ol className="breadcrumb">
          <li><Link to="/">Forsiden</Link></li>
          <li>Garantitester</li>
        </ol>

        <div className="page-header">
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <h1>
                Garantitester
              </h1>
            </div>
          </div>
        </div>

        {this.state.error && this.state.errorText && !this.state.search &&
          <div className="row">
            <div className="col-xs-12 col-sm-6">
              <p className="alert alert-danger">{this.state.errorText}</p>
            </div>
          </div>
        }

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <div className="form-group">
              <label>Merke og modell</label>
              <MakeModelVariantField
                onChange={this.handleMakeModelVariantChange}
                disabled={this.state.searching}
                cls={mmvCls}
                value={{
                  make: this.state.make || null,
                  model: this.state.model || null
                }}
              />
            </div>
          </div>

          <div className="col-xs-12 col-sm-6">
            <div className="form-group">
              <label>Registreringsdato</label>
              <div>
                <DatePicker
                  name="regDate"
                  disabled={this.state.searching}
                  className="form-control"
                  locale="nb"
                  dateFormat="dd.MM.yyyy"
                  selected={this.state.regDate}
                  onChange={(date) => this.handleDateChange('regDate', date)}
                  isClearable={true}
                  showYearDropdown
                  scrollableYearDropdown
                />
              </div>
            </div>
            <div className="form-group">
              <label>Årsmodell</label>
              <input
                className="form-control"
                type="text"
                name="modelYear"
                value={this.state.modelYear || ''}
                disabled={this.state.searching}
                onChange={this.handleFieldChange}
              />
            </div>

            <div className="row">
              <div className="col-xs-12 col-sm-6 col-md-4">
                <div className="form-group">
                  <label>Type</label>
                  <div className="checkbox">
                    <label>
                      <input
                        type="checkbox"
                        name="electric"
                        checked={(this.state.electric === 'true' || this.state.electric === true)}
                        disabled={this.state.searching}
                        onChange={this.handleFieldChange}
                      />
                      El-bil / hybrid
                    </label>
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-6 col-md-4">
                {this.state.make && makeName === 'mitsubishi' &&
                  <div className="form-group">
                    <label>Importtype</label>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          name="mgImport"
                          checked={(this.state.mgImport === 'true' || this.state.mgImport === true)}
                          disabled={this.state.searching}
                          onChange={this.handleFieldChange}
                        />
                        MG-import
                      </label>
                    </div>
                    <div className="checkbox">
                      <label>
                        <input
                          type="checkbox"
                          name="usedImport"
                          checked={(this.state.usedImport === 'true' || this.state.usedImport === true)}
                          disabled={this.state.searching}
                          onChange={this.handleFieldChange}
                        />
                        Bruktimport
                      </label>
                    </div>
                  </div>
                }
              </div>
            </div>

          </div>
        </div>

        <div className="row">
          <div className="col-xs-12 col-sm-6">
            <button
              className="btn btn-primary btn-lg"
              onClick={this.handleSearch}
              disabled={this.state.searching || !this.state.make || !this.state.model}
            >
              SØK
            </button>
            &nbsp;
            <button
              className="btn btn-warning btn-lg"
              onClick={this.resetSearch}
              disabled={this.state.searching}
            >
              NULLSTILL
            </button>
          </div>
        </div>

        <div className="row mf-padding-top-20">
          <div className="col-xs-12">
            <hr/>
          </div>
        </div>

        {this.state.searching &&
          <div className="row mf-padding-top-20 mf-margin-bottom-20">
            <div className="col-xs-12">
              <i className="fa fa-spinner fa-pulse fa-fw"></i> Henter garantidata...
            </div>
          </div>
        }

        {warrantyObjects && warrantyObjects.length > 1 &&
          <h2 className="text-danger">Flere treff <small>Kun det første resultatet vil bli brukt ved visning</small></h2>
        }

        {this.state.search &&
          <div className="row mf-margin-bottom-20">
            {warrantyObjects && warrantyObjects.map((warrantyObject, i) => (
              <div key={i} className="col-xs-12">
                <h2>
                  <Link to={`/warrantyperiods/${makeName}/${warrantyObject.id}`}>
                    {warrantyObject.title}
                  </Link>
                </h2>

                <div className="row">
                  <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5">
                    <strong>Nybilgaranti:</strong>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5">
                    {warrantyObject.standardWarrantyText}
                  </div>

                  <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5">
                    <strong>Rustgaranti:</strong>
                  </div>
                  <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5">
                    {warrantyObject.rustWarrantyText}
                  </div>

                  {warrantyObject.paintWarrantyText &&
                    <div>
                      <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5">
                        <strong>Lakkgaranti:</strong>
                      </div>
                      <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5">
                        {warrantyObject.paintWarrantyText}
                      </div>
                    </div>
                  }

                  {warrantyObject.batteryWarrantyText &&
                    <div>
                      <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5">
                        <strong>Batteri:</strong>
                      </div>
                      <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5">
                        {warrantyObject.batteryWarrantyText}
                      </div>
                    </div>
                  }

                  {this.state.make && makeName === 'mitsubishi' &&
                    <div>
                      <div>
                        <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5 mf-margin-top-10">
                          <strong>Bruktimport:</strong>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5 mf-margin-top-10">
                          {warrantyObject.usedImport ? 'Ja' : 'Nei' }
                        </div>
                      </div>
                      <div>
                        <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5">
                          <strong>MG-import:</strong>
                        </div>
                        <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5">
                          {warrantyObject.mgImport ? 'Ja' : 'Nei' }
                        </div>
                      </div>
                    </div>
                  }

                  <div>
                    <div className="col-xs-12 col-sm-6 col-md-3 mf-margin-bottom-5 mf-margin-top-10">
                      <strong>El-bil / hybrid:</strong>
                    </div>
                    <div className="col-xs-12 col-sm-6 col-md-9 mf-margin-bottom-5 mf-margin-top-10">
                      {warrantyObject.electric ? 'Ja' : 'Nei' }
                    </div>
                  </div>

                  <div className="col-xs-12 mf-margin-top-10">
                    <Link className="btn btn-default" to={`/warrantyperiods/${makeName}/${warrantyObject.id}`}>
                      Gå til garantiperiode
                    </Link>
                  </div>
                </div>
                {i === 0 && <hr/>}
              </div>
            ))}
          </div>
        }

        {this.state.error && this.state.errorText && this.state.search &&
          <div className="row mf-margin-bottom-20">
            <div className="col-xs-12">
              <p className="alert alert-danger">{this.state.errorText}</p>
            </div>
          </div>
        }
      </section>
    );
  }
}

export default WarrantyPeriodTester;
